module.exports = __webpack_public_path__ + "assets/images/logos/1.png";